import Channel from '@/Enums/Channel.enum';
import { IImpressionCalculation } from '@/Interfaces/Forecaster';
import { TabName } from '../TabName.enum';
import { getForecastMetricValue } from '../helpers';
import EstimationCard from './EstimationCard';
import EstimationDatePicker from './EstimationDatePicker';

interface IProps {
  loading: boolean;
  tabNamePrefix: TabName;
  forecast?: IImpressionCalculation;
  showReach: boolean;
  channel?: Channel;
  customDateRangeVariant?: boolean;
  handleDaysInRangeChange: (daysInRange: number) => void;
}

const ForecastTab = ({
  loading,
  forecast,
  showReach,
  channel,
  tabNamePrefix,
  handleDaysInRangeChange,
  customDateRangeVariant,
}: IProps) => (
  <div className='flex w-full h-full flex-col gap-1 justify-evenly items-center'>
    {customDateRangeVariant ? <EstimationDatePicker handleDaysInRangeChange={handleDaysInRangeChange} /> : null}
    <EstimationCard
      tabName={showReach || !channel ? tabNamePrefix : `${tabNamePrefix} ${channel}`}
      value={getForecastMetricValue(loading, 'impressions', forecast)}
      reachValue={showReach ? getForecastMetricValue(loading, 'reach', forecast) : undefined}
    />
  </div>
);

export default ForecastTab;
